import { useParams } from 'react-router'
import { coerceInt } from '@synapex/tools/utils'
import { InviteLinksChannelsWidget } from '@/widgets/analytics/invite-links/ui/InviteLinksChannelsWidget'
import { InviteLinksSitesWidget } from '@/widgets/analytics/invite-links/ui/InviteLinksSitesWidget'
import { useActiveWorkspace } from '@/true-fsd/data/advertiser-account/hooks'

export const LinksPage = () => {
    const { groupId: groupIdString } = useParams<{ groupId: string }>()
    const groupId = groupIdString ? coerceInt(groupIdString) : undefined

    const { activeWorkspace, activeAccount } = useActiveWorkspace()

    if (!groupId) {
        console.error({ groupId, activeWorkspace })

        return null
    }

    //if no such groupId, we should go on groups page

    if (activeWorkspace.workspace_type === 'site') {
        return (
            <InviteLinksSitesWidget
                activeAccount={activeAccount}
                activeSite={activeWorkspace}
                groupId={groupId}
            />
        )
    } else {
        return (
            <InviteLinksChannelsWidget
                activeAccount={activeAccount}
                activeChannel={activeWorkspace}
                groupId={groupId}
            />
        )
    }
}
